import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import '../../pages/Contacts/contacts.css';
import { createContactCompany, updateBusiness } from '../../api/contacts';
import { CustomAlertType } from '../CustomAlert';
import { Container, Form, Modal, Row,   Button } from 'react-bootstrap';

interface IModifyBusinessNameAndVat {
  showModal: boolean;
  hideModal: () => void;
  hideAllModal: Function;
  business_name?: string;
  vat?: string;
  business_id?: number;
  contact_id?: number;
  setErrorMessage: Function;
  setShowError: Function;
  setErrorType: Function;
}

export const ModifyBusinessNameAndVat = ({
  showModal,
  hideModal,
  hideAllModal,
  business_name,
  vat,
  business_id,
  contact_id,
  setErrorMessage,
  setShowError,
  setErrorType
}: IModifyBusinessNameAndVat) => {
  const [businessName, setBusinessName] = useState<string>('');
  const [businessVat, setVat] = useState<string>('');
  const { t } = useTranslation();

  useEffect(() => {
    if (business_id) {
      setBusinessName(business_name ? business_name : '');
      setVat(vat ? vat : '');
    }
  }, [business_id]);


  const save = async () => {
    if (business_id) {
      try {
        const result = await updateBusiness(
          business_id,
          businessName,
          businessVat
        );
        if (result) {
          setBusinessName('');
          setVat('');

          hideModal();
        }
      } catch (error) {
        setBusinessName('');
        setVat('');

        hideAllModal();
        setErrorType(CustomAlertType.ERROR);
        setErrorMessage(t('NOT_SAVED_DATA'));
        setShowError(true);
      }
    } else {
      try {
        const result = await createContactCompany(
          contact_id,
          businessName,
          businessVat
        );
        if (result) {
          setBusinessName('');
          setVat('');

          hideModal();
          setErrorType(CustomAlertType.INFO);
          setErrorMessage(t('SAVED_DATA'));
          setShowError(true);
        }
      } catch (error) {
        setBusinessName('');
        setVat('');

        hideAllModal();
        setErrorType(CustomAlertType.ERROR);
        setErrorMessage(t('NOT_SAVED_DATA'));
        setShowError(true);
      }
    }
  };

  const changeBusinessValue = (businessNameValue: string) => {
    setBusinessName(businessNameValue);
  };
  const changeVatValue = (vatValue: string) => {
    setVat(vatValue);
  };
  return <><Modal show={showModal} keyboard={true} size='xl' onHide={hideModal}>
    <Modal.Header>
      <Modal.Title>{t('MODIFY_BUSINESS_NAME_AND_VAT')}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <Container>
        <Row className='w-100 justify-content-center'>
          <Form>
            <Form.Group className="mb-3" >
              <Form.Label>{t('BUSINESS_NAME')}</Form.Label>
              <Form.Control defaultValue={business_name}
                onChange={(event: any) => changeBusinessValue(event.target.value)} />
            </Form.Group>

            <Form.Group className="mb-3">
              <Form.Label>{t('VAT')}</Form.Label>
              <Form.Control defaultValue={vat} onChange={(event: any) => changeVatValue(event.target.value)} />
            </Form.Group>
            <Button variant="primary" onClick={() => save()}>
              {t('SAVE')}
            </Button>
          </Form>
        </Row>
      </Container>
    </Modal.Body>
  </Modal></>;
};
